import Image from "next/image";
import { clsx } from "clsx";
import darkTheme from "themes/dark";

type CaretProps = {
  itemIsOpen?: boolean;
};

export const Caret = ({ itemIsOpen }: CaretProps) => (
  <Image
    priority
    alt=""
    width={12}
    height={7}
    src={darkTheme.images.caretDown}
    className={clsx(
      "ml-[6px] self-center object-contain transition-all duration-300 ease-in-out",
      itemIsOpen ? "rotate-180" : "rotate-0"
    )}
  />
);
